import { Component } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { PrivacyPolicyComponent } from '@ccab/components-lib';
import { CookiePreferencesComponent } from '@ccab/components-lib';
import { Platform } from 'src/app/modules/home/enum/platform';
import { AcceptCookiesComponent } from '@ccab/components-lib';
import { PrivacyPolicyModalComponent } from '../privacy-policy-modal/privacy-policy-modal.component';
import { PreferencesModalComponent } from '../preferences-modal/preferences-modal.component';

@Component({
  selector: 'app-custom-accept-cookies',
  templateUrl: './custom-accept-cookies.component.html',
  styleUrls: ['./custom-accept-cookies.component.scss']
})
export class CustomAcceptCookiesComponent {
  [x: string]: any;
  constructor(private dialogRef: MatDialogRef<CustomAcceptCookiesComponent>, private dialog: MatDialog) {}

  onAccept(): void {
    this.dialogRef.close(true);
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

  openModalPreferences(): void {
    this.dialog.open(PreferencesModalComponent, {
      disableClose: false
    });
  }

  openPrivacyPolicy(): void {
    this.dialog.open(PrivacyPolicyModalComponent, {
      disableClose: false
    });
  }
}
